import React, { useState } from 'react';
import { ModalWrapper } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { OnoEMailSendForm } from 'components/atoms';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

export interface MailSendModalProps extends PopupProps {
    id: number;
    mail_type: string;    
}

const OnoMailSendModal = ({ isOpen, onClose, id, mail_type }: MailSendModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    

  /* ======================================================
  * hooks
  * ====================================================== */

   /* ======================================================
   * variables
   * ====================================================== */

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onConfirm = () => {
        onClose?.(true);
    };
    
    /* ======================================================
    * methods
    * ====================================================== */
 
  /* ======================================================
   * effects
   * ====================================================== */

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={1280} title={'메일 발송'} closable>
            <OnoEMailSendForm id={id} mail_type={mail_type} onCancel={onCancel} onConfirm={onConfirm}/>                
        </ModalWrapper>  
    )    
};

export default React.memo(OnoMailSendModal);    